<template>
  <div class="section header" :class="{ 'header-scroll': isFixed }">
    <div class="content">
      <div class="pic">
        <div class="img">
          <img
            :src="
              isFixed
                ? require('../assets/images/weicai/blue-logo.png')
                : require('../assets/images/weicai/white-logo.png')
            "
            alt=""
          />
        </div>
        <span class="line"></span>
        <div class="title">创新金融服务 创造美好生活</div>
      </div>
      <ul>
        <li><a href="/">首页</a></li>
        <li><a href="/WeTechnology">We科技</a></li>
        <li><a href="/responsibility">社会责任</a></li>
        <!-- <li><a href="/WeProduct">We产品</a></li> -->
        <!-- <li><a href="/WeCulture">We文化</a></li> -->
        <li><a href="/WeAbout">关于我们</a></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isFixed: false
    }
  },
  mounted () {
    console.log('走到了这里');
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let offsetTop = document.querySelector('.header').offsetTop
      this.isFixed = scrollTop > offsetTop
    }
  }
}
</script>

<style scoped lang="less">
.header {
  height: 86px;
  width: 100%;
  position: fixed;
  top: 0px;
  z-index: 10;
  transition: all 0.3s;

  & > div {
    height: 100%;
    position: relative;
    margin: 0 auto;
    width: 1080px;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pic {
    display: flex;
    width: 300px;
    align-items: center;
    .img {
      width: 70px;
      height: 42px;
      img {
        width: 70px;
        height: 42px;
      }
    }
    .line {
      display: inline-block;
      width: 0;
      margin: 0 19px;
      height: 22px;
      opacity: 0.35;
      border-right: 1px solid #ffffff;
    }
    .title {
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      letter-spacing: 1px;
    }
  }

  ul {
    float: right;

    li {
      float: left;
      margin: 0 38px 0 20px;

      a {
        position: relative;
        height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 22px;
        letter-spacing: 1px;

        &::before {
          box-sizing: border-box;
          cursor: pointer;
          content: "";
          width: 28px;
          color: inherit;
          height: 2px;
          background: #ffffff;
          position: absolute;
          bottom: -9px;
          left: 0;
          right: 0;
          -webkit-transform: scaleX(0);
          -ms-transform: scaleX(0);
          transform: scaleX(0);
          -webkit-transform-origin: right center;
          -ms-transform-origin: right center;
          transform-origin: right center;
          -webkit-transition: -webkit-transform 0.4s cubic-bezier(1, 0, 0, 1);
          transition: -webkit-transform 0.4s cubic-bezier(1, 0, 0, 1);
          transition: transform 0.4s cubic-bezier(1, 0, 0, 1);
          transition: transform 0.4s cubic-bezier(1, 0, 0, 1),
            -webkit-transform 0.4s cubic-bezier(1, 0, 0, 1);
        }
      }

      a:hover,
      a.active {
        &::before {
          transform: scaleX(1);
          transform-origin: left center;
        }
      }
      &:not(:first-child) {
        a {
          &::before {
            left: 16px !important;
          }
        }
      }
    }
  }
}

.header-scroll {
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02);

  .line {
      border-right: 1px solid #004bb3 !important;
    }
    .title {
      color: #004bb3 !important;
    }

  ul li a {
    color: #004bb3;
    &::before{
      background: #1468dd !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue